import { render, staticRenderFns } from "./FontSizeControlV2.vue?vue&type=template&id=ab8e38be"
import script from "./FontSizeControlV2.vue?vue&type=script&lang=js"
export * from "./FontSizeControlV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports